<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md4>
        <material-card color="green" title="Login" text="Enter your user name and password">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    class="purple-input"
                    label="User Name"
                    name="username"
                    v-model="input.username"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    type="password"
                    label="Password"
                    name="password"
                    v-model="input.password"
                    class="purple-input"
                    v-on:keyup.enter="login()"
                  />
                </v-flex>
                <v-flex xs12>
                  <p>{{errorMsg}}</p>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    v-bind:disabled="loading"
                    v-on:click="login()"
                  >Login</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex xs12 md4></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
var restHelper = require("../restHelper").default
var cookieHelper = require("../cookieHelper").default

export default {
  name: "Login",
  data() {
    return {
      input: {
        username: "",
        password: ""
      },
      errorMsg: "",
      env: process.env.NODE_ENV,
      loading: false
    }
  },
  async mounted() {
    if (cookieHelper.getCookie("token") != "") {
      await this.logout()
    }
  },
  methods: {
    async login() {
      this.errorMsg = ""
      this.loading = true

      try {
        var result = await restHelper.login(
          this.input.username,
          this.input.password
        )

        cookieHelper.setCookie("token", result.data.token)
        this.$router.push("/")
      } catch (error) {
        this.errorMsg = error.response.data.message
      }

      this.loading = false
    },

    async logout() {
      this.errorMsg = ""
      this.loading = true

      try {
        var result = await restHelper.logout()
        cookieHelper.setCookie("token", "")
      } catch (error) {
        this.errorMsg = error.response.data.message
      }

      this.loading = false
    }
  }
}
</script>

